import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Account } from 'crono-fe-common/types/account';
import { removeSpecialCharacters } from 'crono-fe-common/utils';

export default function useAccountExists(
  name: string | null,
  editingComplete: boolean,
) {
  // get key value object from searchParameters
  const queryString = new URLSearchParams({
    name: name ? removeSpecialCharacters(name) : '',
    equal: 'true',
  }).toString();

  const request: Request = {
    url: ENDPOINTS.account.exists + '?' + queryString,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.account.exists, queryString],
    queryFn: () => client(request),
    enabled: name !== null && name.length > 0 && editingComplete,
  };

  const { data, ...rest } = useQuery<Response<Account[]>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}
